import { Component } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
    selector: 'app-maintenance-mode-dialog',
    templateUrl: './maintenance-mode-dialog.component.html',
    standalone: true,
    imports: [
        SharedModule,
        MatDialogModule,
    ],
})
export class MaintenanceModeDialogComponent
{
    constructor(
            private _dialogRef: MatDialogRef<MaintenanceModeDialogComponent>,
    ) {
    }

    retry() {
        window.location.reload();
    }

}
